import React, { useEffect, useMemo, useRef, useState } from 'react'
import {Modal, Button, Form, Divider, Tooltip, Select, Spin, Popover} from 'antd'
import { connect, useSelector } from 'react-redux'
import '../NextModal/index.scss'
import { Collapse } from 'antd'
import {CheckPayment, DisabledCheckIcon, DocumentsIco, ModalCloseIco, SpinnerIco, SwiftPdfIco} from '../../../modules/CustomIcons'
import TableComponent from 'components/Table'
import { LOGIN_PAGE, OWNACCOUNT } from 'constants/constants'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import asanLogo from 'assets/images/icons/asan-logo.png'
import questionMark from 'assets/images/icons/question.png'
import { QRCodeSVG } from 'qrcode.react'
import '../../pages/Login/components/Sidebar/SIMAEntrance/sima.scss'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import { RuleTransactionButton } from '../../services/Auth/RuleTransactionButton'
import { API_URL, httpVeryfied } from '../../services/config'
import OtpInput from 'react-otp-input'
import Timer from 'components/Timer'
import '../../pages/Login/components/Sidebar/MessageInput/index.scss'
import { getTransactionStatus } from '../../services/Auth/TransactionStatus'

// import {changeStatus} from '../../store/actions/transfers'
import { Scrollbar } from 'smooth-scrollbar-react'
import type { Scrollbar as BaseScrollbar } from 'smooth-scrollbar/scrollbar'
import { useActions } from '../../hooks/useActions'
import { changeStatusHandler } from 'store/actions/transfers'
import { MinusSmallIco, PlusSmallIco } from '../../../modules/CustomIcons'
import {
  footerBtnsFirstModal,
  footerBtnsSecondModal,
} from 'pages/Transfers/StatusRender'
import DgkFormModal from "../../components/DGKmodals/dgkForm";
import TextAreaField from "components/TextArea";
import SaveAsTemplate from "components/SaveAsTemplate";
import {getPaymentOrderPdfByIbanRef, getTransfersDetail} from "../../services/transfers";
import {modalRender} from "pages/Transfers/TypeStatusRender";
import {checkAmountForRequest, convertBase64} from "../../services/helper";
import { secureLocalStorageGet } from '../../helpers'
import { useTranslation } from 'react-i18next'
import {getPaymentcheck} from "../../services/Transfers/GppTransfer";
import DocumentsPreviewModal from 'components/DocumentsPreviewModal'
import moment from 'moment'
import { getSwiftPdf } from '../../services/Transfers/Swift'

const SIMA_SIGN_DURATION = 300


// Dense decorative value for the blurred placeholder QR shown before "QR
// aktivləşdir" — same string as the login SIMA tab so the two look identical.
const SIMA_QR_PLACEHOLDER = 'https://simaimza.az/placeholder/activate?ref=login&session=00000000-0000-0000-0000-000000000000'

const formatSimaTime = (time: number) => {
  const minutes = Math.floor(time / 60)
  const seconds = time % 60
  return `0${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
}

const formatRemainingTime = (time: number) => {
  const minutes = Math.floor((time % 1200) / 60)
  const seconds = time % 60

  return `0${minutes}:${seconds == 0 || seconds < 10 ? `0${seconds}` : seconds}`
}

const renderTime = ({ remainingTime }) => {
  if (remainingTime === 0) {
    return <div className="timer"></div>
  }

  return (
    <div className="timer">
      <div className="value">{formatRemainingTime(remainingTime)}</div>
    </div>
  )
}
const NextModalTransfers: React.FC<any> = (props: any) => {
  const {t} = useTranslation();
  let custom_class = props.className || ''
  const [nextModalVisible, setNextModalVisible] = useState(
    props.visible || false
  )
  const itemsRub = [
    {
        label: 'Договор',
        value: 'Dogov',
        code: 'ДОГОВ'
    },
    {
        label: 'Инвойс',
        value: 'Inv',
        code: 'ИНВ'
    },
    {
        label: 'Заказ на закупку',
        value: 'Zakaz na zakupku',
        code: 'ЗАК.НА ЗАКУПКУ'
    },
    {
        label: 'Дебетовое авизо',
        value: 'Debet.avizo',
        code: 'ДЕБЕТ.АВИЗО'
    },
    {
        label: 'Декларация',
        value: 'Dekl',
        code: 'ДЕКЛ'
    },
    {
        label: 'Письмо',
        value: 'Pisxmo',
        code: 'ПИСЬМО'
    },
    {
        label: "Решение учредителей",
        value: "Req.ucreditelei",
        code: 'РЕШ.УЧРЕДИТ.'
    },
    {
        label: "Решение суда",
        value: "Req.suda",
        code: 'РЕШ.СУДА'
    },{
        label: "Док., подтверждающий поступл. средств",
        value: "Dok.o postupl.sredstv",
        code: 'ДОК.О ПОСТУПЛ.СРЕДСТВ'
    },
];
const items = [
    {
        label: 'Contract',
        value: 'Contract',
        code: 'CNT',
        key: 1,
    },
    {
        label: 'Invoice',
        value: 'Invoice',
        code: 'INV',
        key: 2,
    },
    {
        label: 'Purchase Order',
        value: 'Purchase Order',
        code: 'PO',
        key: 3,
    },
    {
        label: 'Debit Note',
        value: 'Debit Note',
        code: 'DN',
        key: 4,
    },
    {
        label: 'GB',
        value: 'GB',
        code: 'GB',
        key: 5,
    },
    {
        label: 'Letter',
        value: 'Letter',
        code: 'LETTER',
        key: 6,
    },
    {
        label: "Shareholders' resolution",
        value: "Shareholders' resolution",
        code: 'SHAREHOLD.RESOL',
        key: 7,
    },
    {
        label: "Court's decision",
        value: "Court's decision",
        code: 'COURT.DECIS',
        key: 8,
    }, 
    {
        label: "Incoming SWIFT",
        value: "Incoming SWIFT",
        code: 'INC.SWIFT',
        key: 9,
    },
];
  const text = (
      <div className="ant-tooltip-inner__data">{t("settings.asanInfo")}<br />
        <span><a href='https://www.asanimza.az' target="_blank">www.asanimza.az</a></span>
      </div>
  )
  const [asanModalVisible, setAsanModalVisible] = useState(false)
  const [simaModalVisible, setSimaModalVisible] = useState(false)
  const [simaQrCode, setSimaQrCode] = useState<string>('')
  const [simaTimeLeft, setSimaTimeLeft] = useState(SIMA_SIGN_DURATION)
  const [simaExpired, setSimaExpired] = useState(false)
  const [simaSignError, setSimaSignError] = useState(false)
  const [simaSignErrorMsg, setSimaSignErrorMsg] = useState('')
  const simaPollingActive = useRef(false)
  // Remembers how the SIMA signing flow was started so "QR aktivləşdir" can
  // replay the exact same request after the QR expires.
  const simaRetryRef = useRef<() => void>(() => {})
  const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
  const [showSuccessOrError, setShowSuccessOrError] = useState(false)
  const [showDeleteModalVisible, setShowDeleteModalVisible] = useState(props.visibleDeleteModal ?? false)

  const [transactionButtonsStatus, setTransactionButtonsStatus] =
    useState<RuleTransactionButton>()
  const [verifyCode, setVerifyCode] = useState<number>()
  const [phoneNumber, setPhoneNumber] = useState<string>()
  const [otpNumberCount, setOtpNumberCount] = useState<number>(6)
  const [otpCode, setOtpCode] = useState<number[]>([])
  const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
  const [otpCodeError, setOtpCodeError] = useState('')
  const [activePanel, setPanel] = useState(false)
  const [activePanelNotify, setPanelNotify] = useState(false)
  const [deletedLoading, setDeletedLoading] = useState(false)
  const [deletedMessage, setDeletedMessage] = useState('')
  const [footerBtnsSecond, setFooterBtnsSecond] = useState(footerBtnsSecondModal)
  const [footerBtnsFirst, setFooterBtnsFirst] = useState(footerBtnsFirstModal)
  const [visible, setVisible] = useState(false);
  const [reset, setReset] = useState<boolean>(false)
  const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
  let channel = secureLocalStorageGet('channel')
  const [errorService, setErrorService] = useState("")
  const [smsClicked, setClicked] = useState(true)
  const modalData = props.data
  const [form] = Form.useForm()
  const selectOptions = ['AZ', 'EN','RU']
  const [selectLang,setLanguage] = useState('AZ')
  const [multipleButton, setMultipleButton] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingApprove, setLoadingApprove] = useState<boolean>(false)
  const scrollbar = useRef<BaseScrollbar | null>(null)
  const [showTimeError, setShowTimeError] = useState(false)
  const [popupType, setPopupType] = useState("success")
  const { Panel } = Collapse
  const [openDgkFormModal, setOpenDgkFormModal] = useState(false);
  const [modalText, setModalText] = useState<string>(props.nextModalText)
  const [documentsModalvisible,setDocumentsModalVisible] = useState(false)
  const language = localStorage.getItem("i18nextLng")
  // console.log("modalData",modalData?.groups);
  const rowRef = useRef(null);
  const [prevColor, setPrevColor] = useState("");
  
  useEffect(() => {
    if (rowRef.current && rowRef.current.previousElementSibling) {
      const prevRow = rowRef.current.previousElementSibling;
      const color = getComputedStyle(prevRow).backgroundColor;
      console.log("ee",color);
      
      setPrevColor(color);
    }
  }, [nextModalVisible]);
const isPrevWhite = prevColor === "rgb(243, 246, 250)";
// console.log("is",isPrevWhite);

  const content = (
      <div>
        <p onClick={props.handleGetFileClick} className={'pdf_text'}>{t("transfers.seperatePDF")}</p>
        <p onClick={props.handleGetFileClickMultiple} className={'pdf_text'}>{t("transfers.multiplePDF")}</p>
      </div>
  );
  useEffect(
      () => {
        if(!smsClicked) {
          let timer1 = setInterval(() => setClicked(true), 20 * 1000);
          return () => {
            clearInterval(timer1);
          }
        }
      },
      [smsClicked]
  );

  useEffect(() => {

    setErrorService("")
    setModalText(props.nextModalText)
    setLoadingApprove(false)
    setNextModalVisible((old_value) => props.visible)


  }, [props.visible, props.data])
  const [previewModal,setPreviewModal] = useState([])
const builtDgkData = useMemo(() => {
  const td = props.tableData || {};
// console.log("ererr",td.ccyType);
console.log("td",td.ygb)
  if (Array.isArray(td.ygb) && td.ygb.length > 0) {
    return {
      type: "YGB",
      pages: td.ygb.map((item: any, idx: number) => ({
        key: item.gbNumber || `ygb-${idx}`,
        gbNo: item.gbNumber,
        summary: {
          name: item.customerFullname,
          receiverCountry: item.beneficiaryCountry,
          invoiceCost: item.ygbInvoiceCost,
          operationAmount: item.ygbOperationAmount,
          egbSum: item.ygbRemainderAmount,
          invoiceCurrency: item.ccy,
          operationCurrency: item.ccy,
          egbCurrency: item.ygbRemainderCcy,
        },
        form: {
          contractNo: item.contractNumber,
          contractDate: item.ygbDocDate,
          receiverCountryId: item.country,
          receiverName: item.beneficiaryName,
          transferredAmount: item.ygbAmount,
          currencyType: item.ccy,
          exchange: item.exchange || "",
        },
      })),
      accountCurrency: td.ccyType,
    };
  }

  if (Array.isArray(td.act) && td.act.length > 0) {
    return {
      type: "AKT",
      pages: td.act.map((item: any, idx: number) => ({
        key: `akt-${idx}`,
        form: {
          actDocDate: item.actDocDate,
          noActDocNumber: !!item.noActDocNumber,
          actDocNumber: item.actDocNumber,
          actDocCost: item.actDocCost,
          actTransCost: item.actTransCost,
          currencyType: item.ccyCode,
          actExchange: item.actExchange || "",
          actSender: item.actSender,
          actServiceProvider: !!item.actServiceProvider,
          actServiceProviderName: item.actServiceProviderName,
          goodServiceInfo: item.goodServiceInfo,
          countryId: item.country,
          note: item.note,
        },
      })),
      accountCurrency: td.ccyType,
    };
  }

  if (Array.isArray(td.advance) && td.advance.length > 0) {
  const form: Record<string, any> = {};

  td.advance.forEach((item: any, idx: number) => {
    form[`contNo-${idx}`] = item.advanceInvoiceNumber || "";
    form[`date-${idx}`] = item.advanceDate || "";
    form[`accountNo-${idx}`] = item.accountNumber || "";
    form[`avansReceiverCountryId-${idx}`] = item.country || "";
    form[`avansReceiver-${idx}`] = item.beneficiaryName || "";
    form[`avansTransferredAmount-${idx}`] = item.advanceAmount || "";
    form[`avansCurrencyType-${idx}`] = item.ccy || "";
    form[`avansExchange-${idx}`] = item.exchange || "";
  });

  return {
    type: "Avans",
    accountCurrency: td.ccyType || td.advance?.[0]?.ccy || "",
    pinCode: td.advance?.[0]?.pin || "",
    summary: {
      pinCode: td.advance?.[0]?.pin || "",
      taxId: td.advance?.[0]?.taxNumber || "",
      name: td.advance?.[0]?.customerFullName || "",
    },
    form,
    detailsCount: td.advance.length,
    advance: td.advance,
  };
}

  return null;
}, [props.tableData]);
const dgkPayload = useMemo(() => {
  const td = props.tableData || {};

  if (Array.isArray(td.ygb) && td.ygb.length > 0) {
    return {
      type: "YGB",
      data: td.ygb,
      accountCurrency: td.ccyType,
    };
  }

  if (Array.isArray(td.act) && td.act.length > 0) {
    return {
      type: "AKT",
      data: td.act,
      accountCurrency: td.ccyType,
    };
  }

  if (Array.isArray(td.advance) && td.advance.length > 0) {
    return {
      type: "AVANS",
      data: td.advance,
      accountCurrency: td.ccyType,
    };
  }

  return null;
}, [props.tableData]);
const dgkTotalPage = useMemo(() => {
  return dgkPayload?.data?.length || 0;
}, [dgkPayload]);
  useEffect(()=>{
    let documentArr:any = []
    if(props.tableData?.transferDocs?.length>0 && props.tableData.trnType === 'SWIFT'){
      let i=0
     console.log(props.tableData?.transferDocs)
      props.tableData?.transferDocs?.map((row)=>{
          documentArr.push({
              "key":i,
              "docId": row.docId,
              "docName": row.docName,
              "docNumAbsent": row.docNumAbsent ==='true' ? true : false,
              "docNum": row.docNum,
              "docDate": moment(row.docDate).format('MM.DD.YYYY'),
              "docNote": row.docNote,
              "docNameLabel":items.find((i)=>i.value===row.docName)?.label,
              "isUsed":true
          })
         
          i++
      })
     
  }else if(props.tableData?.transferDocs?.length>0 && props.tableData.trnType === 'SWIFT_RUB'){
    let i=0
    console.log(props.tableData?.transferDocs)

     
      props.tableData?.transferDocs?.map((row)=>{
          documentArr.push({
              "key":i,
              "docId": row.docId,
              "docName": row.docName,
              "docNumAbsent": row.docNumAbsent ==='true' ? true : false,
              "docNum": row.docNum,
              "docDate": moment(row.docDate).format('MM.DD.YYYY'),
              "docNote": row.docNote,
              "docNameLabel":itemsRub.find((i)=>i.value===row.docName)?.label,
              "isUsed":true
          })
         
          i++
      })

      
  }


  setPreviewModal(documentArr)
  },[props.tableData?.transferDocs?.length>0])

  useEffect(() => {
    setTimeout(() => {
      if(scrollbar.current && props.data?.rubNote)
        scrollbar.current?.scrollTo(undefined, 100000  );
    }, 300);
  },[props.visible, modalData])

  useEffect(() => {
    setLanguage('AZ')

    setPanel(false)
    setPanelNotify(false)
    let  template = false;
    if(props.data !== undefined && props.data['modalTitle'] === t("home.currencyExchange"))
      template = true;
    const group = props.data;
    if(props.btnData !== undefined && props.btnData !== {}) {
      footerBtnsSecond[0]['visible'] = props.btnData['singlePdfButton'];
      footerBtnsSecond[1]['visible'] = props.btnData['swiftButton'];
      footerBtnsSecond[2]['visible'] = props.btnData['adocButton'];
      // SIMA-adoc button: shown only for BANK_SUCCESS + SIMA-signed transfers
      // (computed by the parent and passed as simaAdocVisible).
      footerBtnsSecond[3]['visible'] = !!props.simaAdocVisible;
      footerBtnsFirst[0]['visible'] = props.btnData['repeatButton'];
      footerBtnsFirst[1]['visible'] = props.btnData['editButton'];
      if (!template)
        footerBtnsFirst[2]['visible'] = props.btnData['saveAsTemplateButton'];
      else
        footerBtnsFirst[2]['visible'] = false;
      footerBtnsFirst[3]['visible'] = props.btnData['deleteButton'];
    } else {
      footerBtnsSecond[0]['visible'] = false;
      footerBtnsSecond[1]['visible'] = false;
      footerBtnsSecond[2]['visible'] = false;
      footerBtnsSecond[3]['visible'] = !!props.simaAdocVisible;
      footerBtnsFirst[0]['visible'] = false;
      footerBtnsFirst[1]['visible'] = false;
      footerBtnsFirst[2]['visible'] = false;
      footerBtnsFirst[3]['visible'] = false;
    }
    if(props.multiple) {
      setMultipleButton(true);
    }
    else {
      setMultipleButton(false);
    }
    // setScroolBottom(true);
  }, [props.selectedType, props.multiple, props.data, props.simaAdocVisible])
  // let totals:any;
  useEffect(() => {

    setShowDeleteModalVisible((old_value) => props.visibleDeleteModal)
  }, [props.visibleDeleteModal])

  const onClose = () => {
    props.onClose((old_value) => false)

    setNextModalVisible(false)
    setAsanModalVisible(false)
    setOtpCodeModalVisible(false)
    setShowSuccessOrError(false)
    setShowDeleteModalVisible(false)
  }

  const showAsanModal = () => {
    setNextModalVisible(false)
    setAsanModalVisible(true)
  }

  const showOtpCodeModal = () => {
    setNextModalVisible(false)
    setOtpCodeModalVisible(true)
    setClicked(false)
    setOtpCode((old_data) => [])
    setOtpCodeHasError((old_data) => false)
    setOtpCodeError('');
  }

  const hideOtpCodeModal = () => {
    setNextModalVisible(true)
    setOtpCodeModalVisible(false)
  }

  const onClosePanel = () => {
    setPanel(!activePanel)
  }

  const onClosePanelNotify = () => {
    setPanelNotify(!activePanelNotify)
  }

  useEffect(() => {
    simaPollingActive.current = simaModalVisible && !simaExpired
  }, [simaModalVisible, simaExpired])

  // Restart the countdown whenever a fresh QR arrives — both on the initial
  // request and after "QR aktivləşdir" replays it (which swaps simaQrCode).
  useEffect(() => {
    if (!simaModalVisible || simaExpired || !simaQrCode) return
    setSimaTimeLeft(SIMA_SIGN_DURATION)
    const timer = setInterval(() => {
      setSimaTimeLeft(prev => {
        if (prev <= 1) { clearInterval(timer); setSimaExpired(true); return 0 }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [simaModalVisible, simaQrCode])

  const checkSimaSigningStatus = (code: string) => {
    simaPollingActive.current = true
    return new Promise((resolve, reject) => {
      function checkResponse() {
        if (!simaPollingActive.current) return
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            if (!simaPollingActive.current) return
            let data = response.data.data
            if (data?.lastStatus == 'SIGNATURE_CREATED' && response?.data?.status == 'SUCCESS') {
              if (data?.trnDetails?.length > 0 && data.trnDetails[0].status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if (data?.trnDetails?.length > 0 && data.trnDetails[0].status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"))
              else if (data?.trnDetails?.[0]?.trnStatus === "BANK_SUCCESS")
                setModalText(t("notification.transferSentToBank"))
              else
                setModalText(t("notification.transferCreatedSigned"))
              setPopupType('success')
              setSimaModalVisible(false)
              setNextModalVisible(false)
              setShowSuccessOrError(true)
            } else if (data?.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              setSimaSignErrorMsg(response.data.message || t("notification.errorOccured"))
              setSimaSignError(true)
            }
          }).catch(() => {
            if (!simaPollingActive.current) return
            setSimaSignErrorMsg(t("notification.errorOccured"))
            setSimaSignError(true)
          })
      }
      window.setTimeout(checkResponse, 4000)
    })
  }

  const checkAsanVerifyCodeTransfers = (code: number) => {
    return new Promise((resolve, reject) => {
      function checkResponse() {
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            let data = response?.data?.data
            if (data?.lastStatus == 'SIGNATURE_CREATED' && response?.data?.status == 'SUCCESS') {
              if(data?.trnDetails[0].status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if(data?.trnDetails[0].status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"));
              else if(data?.trnDetails[0].trnStatus === "BANK_ERROR")
                if (data?.trnDetails[0].status === "LIMIT")
                {
                  setModalText(data?.trnDetails[0].message)
                  setPopupType('error');
                } else {
                  setModalText(t("notification.errorOccuredWhenSendToBank"));
                }
              else if(data?.trnDetails[0].trnStatus !== "BANK_SUCCESS") {
                if(data?.userRole === "SIGNER")
                  setModalText(t("notification.transferSigned"));
                else
                  setModalText(t("notification.transferConfirmed"));
                setPopupType('success');
              } else if (props.selectedType === "BANK_ERROR") {
                setModalText(t("notification.transferSentToBank"));
                setPopupType('success');
              } else if(data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
                setModalText(t("notification.transferSentToBank"));
                setPopupType('success');
              }
              setAsanModalVisible(false)
              setShowSuccessOrError(true)
            } else if (data.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              if(data?.trnDetails[0].trnStatus === "BANK_ERROR")
                if (data?.trnDetails[0].status === "LIMIT")
                {
                  setModalText(data?.trnDetails[0].message)
                  setPopupType('error');
                } else {
                  setModalText(t("notification.errorOccuredWhenSendToBank"));
                }
              else
                setModalText(response.data.message !== null ? response.data.message : "")
              setAsanModalVisible(false)
              setShowSuccessOrError(true)
              setPopupType("error")
            }
          }).catch((e) => {
            setAsanModalVisible(false)
            setShowSuccessOrError(true)
            setPopupType("error")
            setModalText(t("notification.errorOccured"))
        })
      }
      checkResponse()
    })
  }
      const getTotals = (list:any) => {
      let totalCount = 0;
      let totalAmount = 0;
      let totalCommission = 0;

      list.forEach((item:any) => {
        item.data.forEach((d:any) => {
          if (d.label === t("transfers.groupTransferCount")) {
            totalCount += Number(d.value);
          }
          if (d.label === t("transfers.groupTransferAmount")) {
            totalAmount += Number(d.value);
          }
          if (d.label === t("transfers.groupTransferComm")) {
            totalCommission += Number(d.value);
          }
        });
      });

      return {
        totalCount,
        totalAmount: totalAmount.toFixed(2),
        totalCommission: totalCommission.toFixed(2),
      };
    };
  
  const sendTransactionRequest = (RequestType: string) => {
    setErrorService("")
    // setModalText(props.nextModalText)
    // setPopupType("success")
    if(RequestType === 'SAVE')
      setLoading(true)
    else
      setLoadingApprove(true)
    props.callBackApi(RequestType).then((res) => {
      setLoading(false)
      setLoadingApprove(false)
      if(res?.resultMessage === "SUCCESS") {
        if (RequestType === 'SAVE') {
          onClose()
          setModalText(t("notification.transferCreated"));
          setShowSuccessOrError((old_status) => true)
        }
        else if (RequestType === 'APPROVE' || RequestType === 'SEND_BANK') {
          if(RequestType === 'APPROVE') {
            if(res?.fileDescriptors[0]?.trnStatus === "BANK_SUCCESS") {
              if (res?.fileDescriptors[0]?.status === "WARN")
                setModalText(t("notification.sentToBank"))
              else if (res?.fileDescriptors[0]?.status === "OUTOF")
                setModalText(t("notification.sentToBankAndProcessedNextDay"));
              else
                setModalText(t("notification.transferSentToBank"));
            }
            else
              setModalText(t("notification.transferConfirmed"));
            setPopupType('success');
          } else {
            if(res?.fileDescriptors[0]?.status === "WARN")
              setModalText(t("notification.sentToBank"))
            else if(res?.fileDescriptors[0]?.status === "OUTOF")
              setModalText(t("notification.sentToBankAndProcessedNextDay"));
            else
              setModalText(t("notification.transferSentToBank"));
            setPopupType('success');
          }
          setNextModalVisible(false)
          setShowSuccessOrError(true)
        }
        else {
          if (channel === 'TOTP' || channel === 'OTP') {
            // let phone_number = localStorage.getItem('phoneNumber');
            let phone_number = secureLocalStorageGet('phoneNumber');
            let last_4_number = phone_number.slice(-4)
            let make_phone_number =
                last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)

            setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))
            setPhoneNumber((old_data) => make_phone_number)
            showOtpCodeModal()
          } else if (channel === 'SIMA') {
            const qrCode = res?.data?.qrCode || ''
            const txCode = res?.data?.verification
             console.log("res3",res);
            simaRetryRef.current = () => sendTransactionRequest(RequestType)
            setSimaQrCode(qrCode)
            setSimaExpired(false)
            setSimaSignError(false)
            setSimaSignErrorMsg('')
            setSimaModalVisible(true)
            checkSimaSigningStatus(txCode)
          } else {
            let verify_code = res.data.verification
            setVerifyCode((old_code) => verify_code)
            checkAsanVerifyCodeTransfers(res.verfication)
            showAsanModal()
          }
        }
      } else {
        if(res?.resultCode !== "500" && res?.resultCode !== "BrServiceErr") {
          setErrorService((res?.detail !== undefined ? res?.detail : '' + ' ') + (res?.message !== undefined ? res?.message : '' + ' ') + (res?.resultMessage !== undefined ? res?.resultMessage : ''));
        } else {
          setNextModalVisible(false)
          setShowSuccessOrError(true)
          if(props.selectedType === "BANK_ERROR")
            setModalText(t("transfers.useSendToBankButtonAgain"))
          else
          setModalText(t("notification.errorOccuredWhenSendToBank"));
          setPopupType('error');
        }
      }
    }).catch((e) => {
      setLoading(false)
      setLoadingApprove(false)
      setErrorService(e?.data?.detail)
    })
  }
  // function downloadHTML(fileName: string, fileContent: string) {
  //   const decodedContent = decodeURIComponent(escape(atob(fileContent)));; // Decode base64
  //   const linkSource = `data:text/html;charset=utf-8,${encodeURIComponent(decodedContent)}`
  //   const downloadLink = document.createElement('a')
  //   downloadLink.href = linkSource
  //   downloadLink.download = fileName
  //   downloadLink.click()
  // }
  function downloadHTML(files:any){
    files?.map((file:any)=>{
      const fileName=`${t("transfers.receiptnum")}${file?.receiptNumber}`
      const fileBase64=file?.receiptPrintContent
      const decodedContent = decodeURIComponent(escape(atob(fileBase64))); // Decode base64
      const linkSource = `data:text/html;charset=utf-8,${encodeURIComponent(decodedContent)}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = fileName.endsWith('.html') ? fileName : `${fileName}.html`; // Ensure .html extension
      downloadLink.click();
    })

  }

  const handleDownloadCheck = async (selectedRowKeys,lang) => {

    const data = await getPaymentcheck(selectedRowKeys,lang)

    if(data?.code == '400' || data?.message !== 'SUCCESS'){
      setShowTimeError(true)
    }else{
      return downloadHTML(
          // `${t("transfers.receiptnum")}${data?.receipResultList[0].receiptNumber}`,
          data.receipResultList
          // [0].receiptPrintContent
      )
    }
  }

  // const handleDownloadCheck = async (selectedRowKeys,lang) => {
  //   const data = await getPaymentcheck(selectedRowKeys,lang)
  //   if(data?.code == '400' || data?.message !== 'SUCCESS'){
  //     setShowTimeError(true)
  //   }else{
  //     return downloadHTML(`${t("transfers.receiptnum")}${data?.receipResultList[0].receiptNumber}`,data.receipResultList[0].receiptPrintContent)
  //   }

  const sendTransactionApprove = (RequestType: any) => {
    setErrorService("")
    setModalText(props.nextModalText)
    setPopupType("success")
    setLoadingApprove(true)
    props.callBackApi(RequestType).then((res) => {
      setLoadingApprove(false)
      if(res?.resultMessage === "SUCCESS") {
        if (RequestType === 'APPROVE') {
          setModalText(t("notification.transferCreatedConfirmed"));
          setPopupType('success');
          setNextModalVisible(false)
          setShowSuccessOrError(true)
        }
        else {
          let channel = secureLocalStorageGet('channel')
          if (channel === 'TOTP' || channel === 'OTP') {
            // let phone_number = localStorage.getItem('phoneNumber');
            let phone_number = secureLocalStorageGet('phoneNumber');
            let last_4_number = phone_number.slice(-4)
            let make_phone_number =
                last_4_number[0] + last_4_number[1] + '-' + last_4_number.slice(-2)
            setPhoneNumber((old_data) => make_phone_number)
            setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))
            showOtpCodeModal()
          } else if (channel === 'SIMA') {
            const qrCode = res?.qrCode || ''
            const txCode = res?.verfication
            console.log(txCode);
             console.log("res4",res);
            simaRetryRef.current = () => sendTransactionApprove(RequestType)
            setSimaQrCode(qrCode)
            setSimaExpired(false)
            setSimaSignError(false)
            setSimaSignErrorMsg('')
            setSimaModalVisible(true)
            checkSimaSigningStatus(txCode)
          } else {
            setVerifyCode((old_code) => res.verfication)
            showAsanModal()
            checkAsanVerifyCodeTransfers(res.verfication)
          }
        }
      } else {
        if(res?.resultCode !== "500") {
          setErrorService((res?.detail !== undefined ? res?.detail : '' + ' ') + (res?.message !== undefined ? res?.message : '' + ' ') + (res?.resultMessage !== undefined ? res?.resultMessage : ''));
        } else {
          setNextModalVisible(false)
          setShowSuccessOrError(true)
          setModalText(t("notification.errorOccuredWhenSendToBank"));
          setPopupType('error');
        }
      }
    })
    .catch((e) => {
      setLoading(false)
      setLoadingApprove(false)
      setErrorService(e?.data?.detail)
    })
  }

  const handleTransactionReq = () => {
    if (props.btnType) {
      sendTransactionApprove(props.requestType)
    } else {
      sendTransactionRequest('SIGN')
    }
  }

  // "QR aktivləşdir" (shown only after the QR expires): replay the original
  // signing request to fetch a fresh QR.
  const retrySimaSign = () => {
    simaPollingActive.current = false
    setSimaQrCode('')
    setSimaExpired(false)
    setSimaSignError(false)
    setSimaSignErrorMsg('')
    setSimaTimeLeft(SIMA_SIGN_DURATION)
    simaRetryRef.current()
  }

  const reSend = () => {
    setClicked(false)
    handleTransactionReq();
    setReset(true);
    setTimeout(() => setReset(false), 1000);
  }

  const handleValue = (value: any) => {
    setOtpCode(value)
  }

  const checkOTPCode = () => {
    setModalText(props.nextModalText)
    setLoading(true)

    setPopupType("success")
    if (otpCode.length == 5 || otpCode.length == 6) {
      getTransactionStatus(otpCode).then((res) => {
        if (res.status === 'ERROR' && res.code === 3) {
          setOtpCodeHasError((old_data) => true)
          setOtpCodeError(res.message);
        }else if(res.status === 'ERROR' && res.code === 5){
          setOtpCodeHasError((old_data) => true)

        } else if (res.status === 'ERROR' && res.code === 500) {
          setOtpCodeHasError((old_data) => false)
          setOtpCodeModalVisible(false)

          if (res?.data?.trnDetails[0].status === "LIMIT")
          {
            setModalText(res?.data?.trnDetails[0].message)
            setPopupType('error');
          } else {
            setModalText(t("notification.errorOccuredWhenSendToBank"));
          }
          setPopupType('error');
          setShowSuccessOrError(true)
        } else {
          if(res?.data?.trnDetails[0].status === "WARN")
            setModalText(t("notification.sentToBank"))
          else if(res?.data?.trnDetails[0].status === "OUTOF")
            setModalText(t("notification.sentToBankAndProcessedNextDay"));
          else if(res?.data?.trnDetails[0].trnStatus === "BANK_ERROR")
            if (res?.data?.trnDetails[0].status === "LIMIT")
            {
              setModalText(res?.data?.trnDetails[0].message)
              setPopupType('error');
            } else {
              setModalText(t("notification.errorOccuredWhenSendToBank"));
            }
          else if(res?.data?.trnDetails[0].trnStatus !== "BANK_SUCCESS") {
            if(res?.data?.userRole === "SIGNER")
              setModalText(t("notification.transferSigned"));
            else
              setModalText(t("notification.transferConfirmed"));
            setPopupType('success');
          } else if (props.selectedType === "BANK_ERROR") {
            setModalText(res?.data?.trnDetails[0].message);
            setPopupType('success');
          } else if(res?.data?.trnDetails[0].trnStatus === "BANK_SUCCESS") {
            setModalText(t("notification.transferSentToBank"));
            setPopupType('success');
          }
          setOtpCodeHasError((old_data) => false)
          setOtpCodeError('');
          setOtpCodeModalVisible(false)
          setShowSuccessOrError(true)
        setLoading(false)

          // props.onStatusChange(true)
        }
      }).catch((e) => {
        setOtpCodeModalVisible(false)
        setShowSuccessOrError(true)
        setLoading(false)

        setPopupType("error")
        setModalText(t("notification.errorOccured"))
      })
    }
   

  }

  const resetForm = () => {
    setOtpCodeModalVisible(false)
    setShowTimeError(true)
    // inputRef.current.__clearvalues__()
  }

  const handleSave = () => {
    setSaveAsTemplatePopupVisible(old_data => true)
  }

   const handleGetSwiftPdf = async () => {
  const ibankrefValue = props.tableData.ibankRef;
  if (!ibankrefValue) return;

  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = String(now.getFullYear()).slice(-2);
  const downloadDate = `${day}${month}${year}`;

  const fileName = `SM_${ibankrefValue}_${downloadDate}.pdf`;

  const postData = {
    fileDetailsList: [{ ibankRef: ibankrefValue }],
  };

  try {
    const { data } = await getSwiftPdf(postData);
    if (data) {
      return downloadPDFFile(fileName, data.fileDetailsList[0]?.fileBase64);
    }
  } catch (err: any) {
    console.log("err", err);
  }
};

function downloadPDFFile(fileName: string, fileBase64: string) {
  const linkSource = `data:application/pdf;base64,${fileBase64}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
} 
// console.log("ps",modalData);
useEffect(() => {
  // console.log("ps",props?.type);  
  // console.log("ps",props?.selectedRow)  ;  
  //  console.log("ps",modalData);
}, [props?.type])
  const modalFooter = () => (
    <>
      {modalData.note && (
        <div className="flex tab_info_box ">
          <span
            className="passive_text_box passive_text_box_rel"
            dangerouslySetInnerHTML={{ __html: modalData.note }}
          />
        </div>
      )}

      {modalData.alertText && (
        <div className="flex tab_info_box tab_alert_box">
          <span
            className="passive_text_box passive_text_box_rel"
            dangerouslySetInnerHTML={{ __html: modalData.alertText }}
          />
        </div>
      )}

      { errorService && (
          <div className="flex tab_info_box tab_alert_box">
        <span
            className="passive_text_box passive_text_box_rel"
            dangerouslySetInnerHTML={{ __html: errorService }}
        />
          </div>
      )}

      <div className={'flex flex_wrap modalTransferSpaceBetween'}>
        <div className="transfers-footer_btns1 transfers-footer_btns--modal flex" style={{position: 'relative',bottom: 12 }}>
          { !multipleButton && <ul className="flex">
            <li>
              <div className="pagination-selector language-selector"
                   style={{ left: '0px', margin: '0px 20px auto 0px' }}
              >
                <Select
                  // open={true}
                  defaultValue={'AZ'}
                  placeholder="AZ"
                  // width={64}
                    onChange={(value:any) => setLanguage(value)}
                >
                  {/*{console.log(selectLang)}*/}
                  {selectOptions.map((item) => {
                    return <option value={item}>{item}</option>
                  })}
                </Select>
              </div>
            </li>

            {footerBtnsSecond.map((item) => {
              return (
                  item.visible &&
                  <li style={{display:"flex"}}>
                   <Tooltip className="footer-tooltip" title={item.title}>
                     { item.key == 'pdf' ?
                         props.loadingPdf ?
                             <div className='ant-btn exportLoadingdiv'><Spin indicator={<SpinnerIco />} /></div>
                             :
                              props.multiple ?
                                     <Popover
                                         // className = "btn-popover"
                                         placement="top"
                                         content={content}
                                         trigger="click"
                                         visible={visible}
                                         onVisibleChange={() => setVisible(!visible)}
                                     >
                                       <Button
                                           icon={item.icon}
                                           disabled={!item.visible || loadingApprove}
                                       />
                                     </Popover> :
                                   <>
                                     <Button
                                         icon={item.icon}
                                         disabled={!item.visible || loadingApprove}
                                         onClick={()=>
                                             props.handleGetFileClick(selectLang)
                                         }
                                     />
                                     {/*{ console.log(props.tableData.ibankRef)*/}


                                   </>

                         :
                         <Button
                               icon={item.icon}
                               disabled={!item.visible || loadingApprove || item.key == 'swift'}
                               onClick={
                                   item.key == 'simaadoc'
                                 ? props.handleGetSimaAdocFileClick
                                 : (item.key == 'adoc'
                                   ? props.handleGetAdocFileClick
                                   : props.handleOtherClick)
                               }
                         />
                     }

                    </Tooltip>

                 </li>
              )
            })}
            <li>
              {
                props.tableData.trnType === "GPP" ?


                    <Tooltip className={'qebz-gpp'} title={'Qəbz endir'}>
                      <Button
                          icon={ <CheckPayment/> }
                          disabled={!props.btnData.receiptButton}
                          onClick={()=>handleDownloadCheck(props.tableData.ibankRef,selectLang)}
                      />
                    </Tooltip>
                    :
                    ''

              }
            </li>
           
          </ul>

          }

          { !multipleButton && <ul
              className="flex"
              style={(props.tableData.trnType !== 'SWIFT' && props.tableData.trnType !== 'SWIFT_RUB') ? {marginRight: '86px'} :{}}
          >
            {footerBtnsFirst.map((item) => {
              return (
                  item.visible && <li>
                    <Tooltip className="footer-tooltip" title={item.title}>
                      <Button
                          ghost
                          icon={item.icon}
                          disabled={!item.visible || loadingApprove || props.tableData.trnType === 'GPP'}
                          onClick={
                            item.type === 'repeat'
                                ? props.handleRepeat
                                : item.type === 'edit'
                                ? props.handleEdit
                                : item.type === 'save'
                                    ? handleSave
                                    : props.handleDelete
                          }
                      />

                    </Tooltip>
                  </li>
              )
            })}
          </ul>
          }
           {(props.tableData.trnType === 'SWIFT' || props.tableData.trnType=== 'SWIFT_RUB') && 
            
                
                <div
                // style={{height:'72%',margin:'0 10px'}}
                className='flex '
                >
                   <DocumentsPreviewModal
                visible={documentsModalvisible}
                title={'Köçürməni əsaslandıran sənədlər'}
                children={<h1>documents modal</h1>}
                // onBack={() => }
                page={true}
                data={previewModal}
                onCancel={() => {
                  setDocumentsModalVisible(false);
                }}
                className='documents_modal'
              />
              <Button
                  style={{height:'66%'}}
                  size={'large'}
                  className="transfer_documentButton_main  light-button  refresh_btn btn flex align_center justify_center"
                  >
                  {(props.tableData.trnType === 'SWIFT' || props.tableData.trnType=== 'SWIFT_RUB') && 
                  <Button
                  icon={<DocumentsIco className=''/>}
                  className='flex transfer_documentButton'
                  onClick={(e) => {
                    console.log('documents opened');
                    setDocumentsModalVisible(true);
                  }}
                >
                <p style={{color:"#015CD1"}}>

                {previewModal.length}
                </p>
                </Button>}
                {(props.tableData.trnType === 'SWIFT' || props.tableData.trnType=== 'SWIFT_RUB') && 
                  <Tooltip title={t("common.swiftTooltipText")}>
                                      <div style={{ display: "inline-flex" }}>
                                        <Button
                                          icon={<SwiftPdfIco />}
                                          className="flex transfer_documentButtonn"
                                          disabled={
                                            !(
                                              (props.type === "FP" || props.type === "RP" || props.type === "SWIFT" || props.type === "SWIFT_RUB" ) &&
                                              props.selectedType === "CLOSED"
                                            )
                                          }
                                          onClick={handleGetSwiftPdf}
                                        />
                                      </div>
                                    </Tooltip>
                }
                
              </Button>
                 
              </div>
              }
               <div style={{position: 'relative', bottom: 0,marginLeft:"10px",height:"51px"}}>
                 {dgkPayload && (
                    <Button
                      size="large"
                      className="documents-btn light-button refresh_btn btn flex align_center justify_center"
                      onClick={() => setOpenDgkFormModal(true)}
                      style={{ width: "100px",bottom:"0",height:"61px",border:"1px solid #D9E3EC" }}
                    >
                      <p className="documents-btn-text">
                        {builtDgkData?.type}
                        <span className="active" style={{ color: "#1890ff",marginLeft:"5px" }}>
                            ({dgkTotalPage})
                        </span>
                      </p>
                    </Button>
                  )}
                </div>
          {/* {
                (props.tableData.trnType === 'SWIFT' || props.tableData.trnType === 'SWIFT_RUB')  &&
                <div>
                   <DocumentsPreviewModal
                visible={documentsModalvisible}
                title={'Köçürməni əsaslandıran sənədlər'}
                children={<h1>documents modal</h1>}
                // onBack={() => }
                data={props.tableData.transferDocs}
                onCancel={() => {
                  setDocumentsModalVisible(false);
                }}
                className='documents_modal'
              />
                  <Button
                  size={'large'}
                  style={{height:'66%'}}
                  icon={<DocumentsIco className=''/>}
                  className="light-button nextmodal_documenticon refresh_btn btn flex align_center justify_center"
                  onClick={(e) => {
                    console.log('documents opened');
                    setDocumentsModalVisible(true);
                  }}
                >
                <div>
                {' (' + props.tableData.transferDocs?.length + ')'}
                </div>
                </Button>
              </div>
              } */}
        </div>

        <div className={"flex"}>
          {props.requestType === 'SIGN' && props.selectedType !== "BANK_ERROR" ? (
              <div className={"modalButtonDivSignTransfer"}>
                {
                  loadingApprove ?
                      <div className='ant-btn  exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco/>}/>
                      </div>
                      :
                      !props.disabledSign && <Button
                          size={'large'}
                          htmlType="submit"
                          className="blue-button next_btn btn flex align_center justify_center"
                          disabled={props.disabledSign}
                          onClick={handleTransactionReq}
                      >
                        {t("transfers.sign")}

                      </Button>
                }
              </div>
          ) : ( props.selectedType !== "BANK_ERROR" &&
              <div className={"modalButtonDivApproveTransfer"}>
                {
                  loadingApprove ?
                      <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco/>}/>
                      </div>
                      :
                      !(props.selectedType === "DELETED" || props.disabledSign) && <Button
                          size={'large'}
                          htmlType="submit"
                          className="blue-button next_btn btn flex align_center justify_center"
                          disabled={props.selectedType === "DELETED" || props.disabledSign}
                          onClick={() => {
                            sendTransactionRequest(props.btnType || 'APPROVE')
                          }}
                      >
                        {t("login.confirm")}
                      </Button>
                }
              </div>
          )}
          {
            props.selectedType === "BANK_ERROR" &&
            <div className={"modalButtonDivApproveTransfer"}>
              {
                loadingApprove ?
                    <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco/>}/>
                    </div>
                    :
                    <Button
                        size={'large'}
                        htmlType="submit"
                        className="blue-button next_btn btn flex align_center justify_center"
                        onClick={() => {
                          sendTransactionRequest("SEND_BANK")
                        }}
                    >
                      {t("transfers.sendToBank")}
                    </Button>
              }
            </div>
          }
          <Button
            size={'large'}
            htmlType="submit"
            className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center"
            onClick={onClose}
            disabled={loadingApprove}
          >

            {t("common.close")}
          </Button>
        </div>
      </div>
    </>
  )
  const { changeStatusHandler } = useActions()

  const closeDeleteModal = (isOk?:any) => {
    setShowDeleteModalVisible(false)
    props.onClose(isOk);
  }

  const deleteTransfer = async () => {
    setDeletedMessage("");
    setDeletedLoading(true);
    setDeletedMessage("");
    const data = await props.callBackApi(form.getFieldsValue("DELETEDNOTE"))
    form.setFieldsValue({"DELETEDNOTE": ""})
    setDeletedMessage(data['detail'] === "SUCCESS" ? t("notification.deleted") : data['detail'])
    setDeletedLoading(false);
    setShowDeleteModalVisible(false);
  }

  const onCloseDelete = () => {
    if(deletedMessage === t("notification.deleted")) {
      setDeletedMessage("");
      props.onCloseSuccessModal();
    } else {
      setDeletedMessage("");
      props.onClose();
    }
  }
  useEffect(() => {
    // console.log("er",props.tableData);
    
  }, [props.type === "FP"])
  
  
  return (
    <>
      {nextModalVisible && (
        <Modal
          title={modalData.modalTitle}
          closeIcon={<ModalCloseIco />}
          centered
          width={props.width || 700}
          visible={nextModalVisible}
          onOk={onClose}
          onCancel={onClose}
          className={`manage_faster_menus swift_modal form_next_modal ${props?.className}`}
          keyboard={false}
          focusTriggerAfterClose={false}
          // footer={props.selectedRow === 1 ? false : modalFooter() }
          footer={modalFooter()}
        >
          <Scrollbar
            ref={scrollbar}
            plugins={{
              disableScroll: { direction: 'x' },
            }}
            alwaysShowTracks={true}
          >
            <Form layout="vertical" onFinish={(e) => {}} autoComplete="off">
              {/* groups */}
              {/* groups */}
{modalData.groups?.map((row: any, rowIndex: number) => {
  const isLastGroup = rowIndex === modalData.groups.length - 1;
  let table_class = "";

  if (row?.tableHasBorderBottom) table_class += " has_border_bottom ";
  if (row?.tableHasBorderBottom2) table_class += " has_border_bottom has_border_bottom2 ";
  if (row?.tableHasMarginBottom) table_class += " has_margin_bottom ";
  if (row?.tableHasMargin) table_class += " has_margin ";
  if (row?.tableHasBordertop) table_class += " has_border_top has_border_top2 ";

  return (
    <table className={`table table-hover swift_table form_next_table ${table_class}`}>
      <tbody>

        {row.title && (
          <tr>
            <td className={"table_title"} align={"center"} colSpan={2}>
              <Divider plain orientation="center" className={"tab_divider_center"}>
                {row.title}
              </Divider>
            </td>
          </tr>
        )}

        {row.tableHasDivider && (
          <tr>
            <td className={"table_title"} align={"center"} colSpan={2}>
              <Divider orientation="center" className={"tab_divider_only"} />
            </td>
          </tr>
        )}

                      {/* {row.data?.map((line) => {
                        return (
                          <tr className={line?.rowClass}>
                            <td>{line.label}</td>
                            <td>{line.value}</td>
                          </tr>
                        )
                      })} */}
                      {row.commonList ? (
                        <ul className="flex">
                          {row.data?.map((line: any) => {
                            return (
                              <li className={line?.rowClass}>
                                <div
                                  className="flex"
                                  style={{
                                    flexDirection: 'column',
                                    width: 283,
                                  }}
                                >
                                  <p
                                    style={{
                                      color: '#015cd1',
                                      textAlign: 'center',
                                      background: '#F3F6FA',
                                      padding: '10px 0px',
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                      overflowWrap: "anywhere",
                                      // width: "30%",
                                    }}
                                  >
                                    {line.label}
                                  </p>
                                  <span
                                    style={{
                                      textAlign: 'center',
                                      padding: '10px 0px',
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                      overflowWrap: "anywhere",
                                      // width: "70%",
                                    }}
                                  >
                                    {line.value}
                                  </span>
                                </div>
                              </li>
                            )
                          })}
                        </ul>
                      ) : (
                        row.data?.map((line: any,idx:number) => {
                    
                          
                        const bgColor = idx % 2 === 0 ? "#fff" : "#F3F6FA";
                        if(line.label === t("common.amount")){
                          return(
                            <tr className={line?.rowClass} ref={rowRef}>
                              <td  style={{
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                                width: "30%",
                                padding:"0",
                                paddingBottom:"8px"
                              }}><div style={{
          width: "100%",
          height: "2px",
          padding:"0 0 15px 0",
          backgroundColor: "white",
        }}><div style={{
          height:"3px",
          backgroundColor:"#e7f0f9"
        }}>
          </div></div><p style={{
                                marginTop: isPrevWhite ? "0" : "12px",
                                marginLeft:"46px"
                              }}>{line.label}</p></td>
                              <td style={{
                                padding:"0",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                                width: "70%",
                                paddingBottom:"8px"
                              }}><div style={{
          width: "100%",
          height: "2px",
          padding:"0 0 15px 0",
          backgroundColor: "white",
          // marginBottom: "10px",
        }}><div style={{
          height:"3px",
          backgroundColor:"#e7f0f9"
        }}>
          </div></div><p style={{
                                marginTop: isPrevWhite ? "0" : "12px",
                                marginLeft:"46px"
                              }}>{line.value}</p></td>
                            </tr>
                          )
                        }
                          return (
                            <>
  <tr className={line?.rowClass}>
    <td
      style={{
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        width: "30%",
      }}
    >
      {line.label}
    </td>
    <td
      style={{
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        width: "70%",
      }}
    >
      <div style={{ display: "flex", flexDirection:"column",alignItems: "flex-start" }}>
        {line.value}
      </div>
    </td>
  </tr>

  {props.tableData.trnType === "SWIFT" && props.tableData?.pmtCurr !== props.tableData?.ccyType && line.label === t("home.commission") ? (
    <tr>
      {/* This spans both columns */}
      <td colSpan={2} style={{ textAlign: "center", padding: "1rem 4rem" }}>
        <div
          style={{
            backgroundColor: "#E4F1FF",
            borderRadius: "12px",
            color: "var(--main-color, #015CD1)",
            fontFeatureSettings: "'liga' off, 'clig' off",
            fontFamily: "Gilroy-Regular",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            border: "1px solid #9EC3F0",
            padding: "12px 15px",
            width: "100%",
            textAlign: "center",
            margin: "0 auto",
          }}
        >
          {checkAmountForRequest(props.tableData?.AMOUNT)} {props.tableData?.pmtCurr} ={" "}
          {checkAmountForRequest(props.tableData?.exchAmount)} {props.tableData?.accCurr} &nbsp;
          (1 {props.tableData?.accCurr} = {props.tableData?.rate}{" "}
          {props.tableData?.pmtCurr}) <br />
          {t("transfers.swiftCrossMessage")}
        </div>
      </td>
    </tr>
  ) : null}
</>





                          )
                        })
                      )}
                        {isLastGroup &&
                          props.tableData?.PDF_LIST &&
                          props.tableData.trnType !== 'GPP' &&
                          !props.multiple && (
                            <tr className="pdf_row">
                              <td
                                style={{
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word',
                                  overflowWrap: 'anywhere',
                                  width: '30%',
                                }}
                              >
                                {t('transfers.atachedPDF')}
                              </td>
                              <td
                                style={{
                                  whiteSpace: 'normal',
                                  wordBreak: 'break-word',
                                  overflowWrap: 'anywhere',
                                  width: '70%',
                                }}
                              >
                                {props.tableData?.PDF_LIST?.map((line: any, idx: number) => (
                                  <div key={line.fileName}>
                                    <a
                                      style={{ textAlign: 'center', cursor: 'pointer' }}
                                      onClick={() =>
                                        props.handleGetPdfAdditional(
                                          props.tableData?.ibankRef,
                                          line.fileName,
                                        )
                                      }
                                    >
                                      <p style={{ marginRight: 10 }}>{line.fileName}</p>
                                    </a>
                                  </div>
                                ))}
                              </td>
                            </tr>
                          )}
                    </tbody>
                  </table>
                )
              })}

              {/* edv section */}
              {modalData.edvInfoData && (
                <div className={'box_row'}>
                  <div className={'flex direction_column edv_title_box'}>
                    <h3>{modalData.edvInfoData.title}</h3>
                    <p>{modalData.edvInfoData.description}</p>
                  </div>

                  <table
                    className={`table table-hover swift_table form_next_table form_next_table_transparent_row`}
                  >
                    <tbody>
                      {modalData.edvInfoData.data?.map((line) => {
                        return (
                          <tr>
                            <td>{line.label}</td>
                            <td>{line.value}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              )}
              {modalData?.modalTitle === t("transfers.groupTransferTitle") && (
                (() => {
                  const totals = getTotals(modalData?.groups);

                  return (
                    <>
                    <div className = "toper">
                        <div className = "toperLine"></div>
                        <h3 className="total-title">{t("transfers.groupTotal")}</h3>
                        <div className = "toperLine"></div>
                      </div>
                    <div className="total-summary">
                      <div className='rowContainer'>
                        <div className="total-row-l">
                        <span className="label-total">{t("transfers.countTotal")}</span>
                        <span className="value-total">{totals.totalCount}</span>
                      </div>

                      <div className="total-row">
                        <span className="label-total">{t("transfers.amountTotal")}</span>
                        <span className="value-total">{totals.totalAmount}</span>
                      </div>

                      <div className="total-row-r">
                        <span className="label-total">{t("transfers.comissionTotal")}</span>
                        <span className="value-total">{totals.totalCommission}</span>
                      </div>
                      </div>
                    </div>
                    <div className="totalLine"></div>
                    </>
                  );
                })()
              )}
            </Form>

            {props.data?.rubNote && (
                <div  style={{maxWidth:"fit-content",flexDirection:"column",textAlign:"left",padding: '0 64px',marginTop:55}} className="flex tab_info_box" >

          <span
              id={"info"}
              style={{flexDirection:"column"}}
              className="passive_text_box passive_text_box_rel"
              dangerouslySetInnerHTML={{ __html:props.data?.rubNote}}
          />
                </div>
            )}
            {props.transferData && (
              <>
                {/* <h4 className="table-title">{props.tableTitle}</h4> */}

                <Collapse
                  // style={{ marginTop: 40 }}
                  accordion
                  expandIconPosition={'end'}
                  className={'transfersCollapse collapseHistory'}
                  ghost
                  expandIcon={() => (
                    <div className={'creditCollapse__iconBox'}>
                      {activePanel ? <MinusSmallIco /> : <PlusSmallIco />}
                    </div>
                  )}
                  defaultActiveKey={activePanel ? "1" : "0"}
                  onChange={onClosePanel}
                >
                  {/*<div>*/}
                  <Panel
                    className={'modal_transfer_history'}
                    header={t("transfers.transferHistory")}
                    key="1"
                    extra={<div className={'line'} />}
                  >
                    <TableComponent
                      columns={props.columnsData}
                      className="transfer-table salary-table  modal-table transfers-table__component modal_history_table next_modal_responsive"
                      // className="transfers-table__component home_account_opt_table transfer-table-only"
                      data={props.historyList}
                      scroll={{ x: 0 }}
                      pagination={false}
                      rowSelection={false}
                    />
                  </Panel>
                </Collapse>

                <Collapse
                  accordion
                  expandIconPosition={'end'}
                  className={'transfersCollapse'}
                  ghost
                  expandIcon={() => (
                    <div className={'creditCollapse__iconBox'}>
                      {activePanelNotify ? <MinusSmallIco /> : <PlusSmallIco />}
                    </div>
                  )}
                  onChange={onClosePanelNotify}
                  defaultActiveKey={activePanelNotify ? "1" : "0"}
                >
                  {/*<div>*/}
                  <Panel
                    className={'modal_transfer_history'}
                    header={t("transfers.notes")}
                    key="1"
                    extra={<div className={'line'} />}
                  >
                    {/* <h4 className="table-title">{t("transfers.notes")}</h4> */}
                    <TableComponent
                      columns={props.innerColumnsdata}
                      className="transfer-table salary-table  modal-table transfers-table__component modal_history_table next_modal_responsive"
                      data={props.innerrtableData}
                      scroll={{ x: 0 }}
                      pagination={false}
                      rowSelection={false}
                    />
                  </Panel>
                </Collapse>
              </>
            )}

            {/* )} */}

            { props.selectedRow === 1 ?? <div className={'ant-modal-footer'}>{modalFooter()}</div> }
          </Scrollbar>
        </Modal>
      )}

      {asanModalVisible && (
        <Modal
          title={`ASAN IMZA`}
          // closeIcon={<ModalCloseIco />}
          closable={false}
          centered
          visible={asanModalVisible}
          // onOk={onClose}
          // onCancel={onClose}
          width={422}
          className={`manage_faster_menus swift_modal form_next_modal `}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
        >
          <div className={'flex direction_column asan_sign_popup'}>
            <ul className="office-card__list">
              <li>
                <img src={asanLogo} alt="asan-logo" />
              </li>
              <li>
                <Tooltip
                  id="verificationTooltip"
                  title={text}
                  placement="topRight"
                >
                  <img src={questionMark} alt="question-mark" />
                </Tooltip>
              </li>
            </ul>

            <p>{t(LOGIN_PAGE.MESSAGE)}</p>
            <div className="office-card__statistics mt-15 mb-15">
            {t("modal.controlCode")}
              <span>{verifyCode}</span>
            </div>
            <div className="countdown">
              <CountdownCircleTimer
                isPlaying
                duration={120}
                size={80}
                strokeWidth={3}
                colors={[['#015cd1']]}
                onComplete={resetForm}
              >
                {renderTime}
              </CountdownCircleTimer>
            </div>
          </div>
        </Modal>
      )}

      {simaModalVisible && !simaSignError && (
        <Modal
          title={t("sima.signVia")}
          closable={false}
          centered
          visible={simaModalVisible && !simaSignError}
          width={460}
          className="manage_faster_menus swift_modal"
          bodyStyle={{ padding: '16px 24px 20px', height: 600, overflowY: 'auto' }}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
        >
          <div className="sima-card" style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              {/* <p className="sima-card__subtitle" style={{ marginBottom: 10 }}>
                SİMA mobil tətbiqinə daxil olub QR-kodu skan edin.
              </p> */}
              {simaExpired ? (
                <div className="sima-card__qr sima-card__qr--activate">
                  <QRCodeSVG
                    className="sima-card__qr-placeholder"
                    value={simaQrCode || SIMA_QR_PLACEHOLDER}
                    size={200}
                    level="H"
                    includeMargin={true}
                  />
                  <Button className="sima-card__activate-btn" onClick={retrySimaSign} style={{
                  width:"40%"
                }}>
                    {t("sima.activateQr")}
                  </Button>
                </div>
              ) : simaQrCode ? (
                <div className="sima-card__qr">
                  {/* SİMA payload is ~930 chars; level "H" can't encode that much data,
                      and at 200px the modules are too small to scan. "L" + 260px fits and
                      keeps the code readable by a phone camera. */}
                  <QRCodeSVG value={simaQrCode} size={260} level="L" includeMargin={true} />
                </div>
              ) : (
                <div className="sima-card__qr sima-card__qr--loader"><Spin size="large" /></div>
              )}
              {simaExpired && <p className="sima-card__expired-label">{t("sima.qrExpired")}</p>}
              <p className="sima-card__expire-label">{t("sima.qrExpiryTime")}</p>
              <div className="sima-card__timer-wrap">
                <span className={`sima-card__timer-badge${simaExpired ? ' sima-card__timer-badge--expired' : ''}`}>
                  {formatSimaTime(simaExpired ? 0 : simaTimeLeft)}
                </span>
              </div>
              <ol className="sima-card__steps" style={{ width: 'fit-content', margin: '16px auto 0', paddingLeft: 0 }}>
                <li><span>1</span>{t("sima.step1")}</li>
                <li><span>2</span>{t("sima.step2")}</li>
                <li><span>3</span>{t("sima.step3Sign")}</li>
              </ol>
              <p style={{ width: 325, textAlign: 'center', fontSize: 14, fontWeight: 400, color: '#223142', margin: '15.5px auto 0', lineHeight: 'normal' }}>
                {t("sima.errorHelp")}
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 13 }}>
                <Button
                  size="large"
                  style={{ width: 141, height: 48, padding: '13px 20px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 10, border: '1px solid #015CD1', background: '#fff', color: '#015CD1', fontWeight: 500 }}
                  onClick={() => { setSimaModalVisible(false) }}
                >
                  {t("sima.back")}
                </Button>
              </div>
          </div>
        </Modal>
      )}

      {simaModalVisible && simaSignError && (
        <Modal
          title={t("common.attention")}
          closeIcon={<span className="sima-error__close">×</span>}
          centered
          visible={simaModalVisible && simaSignError}
          width={580}
          className="manage_faster_menus swift_modal sima_error_modal"
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
          onCancel={() => { setSimaModalVisible(false) }}
        >
          <div className="sima-error">
            <div className="sima-error__content">
              <div className="sima-error__icon">
                <span>✕</span>
              </div>

              <div className="sima-error__message">
                <p className="sima-error__title">
                  Xəta baş verdi!
                </p>

                <p className="sima-error__text">
                  {simaSignErrorMsg
                    ? simaSignErrorMsg.replace(', ona görə', ', ona görə\n')
                    : 'Zəhmət olmasa, yenidən cəhd edin.'}
                </p>
              </div>
            </div>

            <div className="sima-error__footer">
              <Button type="primary" onClick={() => { setSimaModalVisible(false) }}>
                {t("common.close")}
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {otpCodeModalVisible && (
        <Modal
          title={ channel == 'OTP' ? t("transfers.signingBySMSCode") : t("transfers.signWithGoogleCode") }
          closeIcon={<ModalCloseIco />}
          centered
          visible={otpCodeModalVisible}
          onOk={hideOtpCodeModal}
          onCancel={hideOtpCodeModal}
          width={422}
          className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
          maskClosable={false}
        >
          <div
            className={
              'flex direction_column align_center otp_code_verify_modal_body'
            }
          >
              { channel == 'OTP' ?
              <p>
                {t("settings.otpcode1")}{phoneNumber} {t("settings.otpcode2")} <br />
                {t("settings.otpcode3")}
            </p>
            : <p>{t("settings.generatedCode")}</p>
             }

            <Form
              form={form}
              onSubmit={(e: any) => e.preventDefault()}
              onFinish={checkOTPCode}
              shouldAutoFocus={true}
              autoComplete="off"
              className={
                otpCodeHasError
                  ? 'message-input-form flex direction_column justify_center has_error'
                  : 'flex direction_column justify_center message-input-form'
              }
            >
              <OtpInput
                value={otpCode}
                onChange={handleValue}
                numInputs={otpNumberCount}
                inputStyle="otpInput"
                isInputNum={true}
                shouldAutoFocus={true}
                className="message-input-form__input"
              />

              { otpCodeHasError && (
                  <>
                    <span className={'verify_code_error flex full justify_center'}>
                      {t("transfers.wrongCodeEntered")}
                    </span>
                    {/*<span className={'verify_code_error flex full justify_center'}>*/}
                    {/*  { otpCodeError }*/}
                    {/*</span>*/}
                  </>
              )}

              <div className={'full flex direction_column'}>
                <ul
                  className="message-form__details full"
                  style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                >
                  <li className="message-form__time">
                    { otpCode ? (
                      <Timer timerEnd={resetForm} reset={reset} />
                    ) : (
                      <span>00:00</span>
                    )}
                  </li>
                  {channel == 'OTP' &&
                    <li>
                      <a onClick={reSend} className={(smsClicked) ? 'active' : 'disabled'}>{t("modal.detailsData")}</a>
                    </li>
                  }
                </ul>

                {/*<Button*/}
                {/*  type={'ghost'}*/}
                {/*  className={'transparent resend_verify_code_btn'}*/}
                {/*  onClick={reSend}*/}
                {/*>*/}
                {/*  SMS kodu yenidən göndər*/}
                {/*</Button>*/}

                <div className="login-form__buttons flex justify_center">
                  <Button
                    size={'large'}
                    className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                    onClick={hideOtpCodeModal}
                  >
                    {t("transfers.back")}
                  </Button>
                  <Button
                    size={'large'}
                    className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                    htmlType="submit"
                    loading={loading}
                  >
                    {t("login.confirm")}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      )}

      {showSuccessOrError && (
        <SuccessOrErrorModal
          visible={showSuccessOrError}
          modalType={popupType}
          modalTitle={popupType === 'success' ? t("home.transfer") : t("notification.attention")}
          modalText={modalText}
          onClose={() => { onClose(); props.onCloseSuccessModal();}}
        />
      )}

      {showTimeError && (
          <SuccessOrErrorModal
              visible={showTimeError}
              modalType={'error'}
              modalTitle={t("notification.attention")}
              modalText={t("notification.errorOccured")}
              onClose={() => { setShowTimeError(false); }}
              onCancel={() => { setShowTimeError(false); setNextModalVisible(true)}}
          />
      )}

      { showDeleteModalVisible && (
          <Modal
              title={'Köçürmənin təfsilatı'}
              closeIcon={<ModalCloseIco />}
              centered
              visible={showDeleteModalVisible}
              onOk={()=>closeDeleteModal(true)}
              onCancel={()=>closeDeleteModal(false)}
              width={422}
              className={`manage_faster_menus swift_modal otp_code_verify_modal`}
              keyboard={false}
              focusTriggerAfterClose={false}
              footer={false}
          >
            <div
            >
              <Form
                  form={form}
                  // onSubmit={(e: any) => }
                  onFinish={deleteTransfer}
                  // shouldAutoFocus={true}
                  autoComplete="off"
                  className={
                    'flex direction_column justify_center message-input-form'
                  }
              >
                <div>
                      <TextAreaField
                          visible={true}
                          labelItem={t("newTransfer.note")}
                          placeholder=""
                          showCount={true}
                          maxLength={'300'}
                          name={'DELETEDNOTE'}
                          // required={true}
                          form={form}
                          allowDestination={true}
                          className={'isReadOnly delete_modal_input'}
                      />
                      <div className="login-form__buttons flex justify_end">
                        { deletedLoading ?
                            <div
                                className="flex align_center justify_center delete_modal_margin ant-btn-lg"
                            >
                              <div className={' exportLoadingdiv'}>
                                <Spin indicator={<SpinnerIco />} />
                              </div>
                            </div>
                        :  <Button
                                size={'large'}
                                className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center delete_modal_margin"
                                htmlType="submit"
                            >
                               {t("home.yes")}
                            </Button>
                        }
                        <Button
                            size={'large'}
                            className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                            onClick={()=>closeDeleteModal(false)}
                        >
                          {t("home.no")}
                        </Button>
                      </div>
                </div>
              </Form>
            </div>
          </Modal>
      )}

      { deletedMessage !== '' && (
          <SuccessOrErrorModal
              visible={deletedMessage !== ''}
              modalType={deletedMessage === t("notification.deleted") ? 'success' : "error"}
              modalTitle={t("home.transfer")}
              modalText={deletedMessage}
              onCancel={() => { onCloseDelete() }}
              modalFooter={<div></div>}
              delete={true}
          />
      )}
      { saveAsTemplatePopupVisible &&
        <SaveAsTemplate
            visible={saveAsTemplatePopupVisible}
            onClose={setSaveAsTemplatePopupVisible}
            trnType={modalData?.modalTitle !== undefined ? modalData?.modalTitle : ""}
            currentForm={props.currentForm}
            tableData={props.tableData}
        />
      }
      <DgkFormModal
        visible={openDgkFormModal}
        setVisible={setOpenDgkFormModal}
        onClose={() => setOpenDgkFormModal(false)}
        dgkType={dgkPayload?.type}
        dgkItems={dgkPayload?.data || []}
        accountCurrency={dgkPayload?.accountCurrency}
      />
    </>
  )
}
const mapDispatchToProps = { changeStatusHandler }

export default connect(null, null)(NextModalTransfers)
